/** Pure edits of the usage sheet lists: a line the user edits becomes confirmed. */

export const replaceAt = <T extends object>(items: T[], index: number, patch: Partial<T>): T[] =>
  items.map((item, position) => (position === index
    ? { ...item, ...patch, ...('status' in item ? { status: 'confirmed' as const } : {}) } as T
    : item));

export const removeAt = <T>(items: T[], index: number): T[] =>
  items.filter((_, position) => position !== index);
